import { LookupDataEnums } from '../../utilities/Constants';
import { useQuery } from 'react-query';
import { useZoneContext } from '../../contexts/useZoneContext';

export const useGetQScores = () => {
    const { zoneApiClient } = useZoneContext();

    return useQuery({
        queryKey: ['get-qscores'],
        queryFn: async () => {
            const response = await zoneApiClient.getZoneSpecificLookupData(LookupDataEnums.QScore);

            if (response.httpResponse.status === 401) {
                window.location.reload();
            }

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve Q Scores.');
            } else if (response.errorMessage) {
                throw new Error(response.errorMessage);
            }

            return response.payload;
        },
    });
};
